// Generated by genversion.
export const version = '1.36.0';
